import { getAppraisalPathname } from '@/components/nav/utils/url-builders';
import { Button } from '@/components/ui/button';
import type { AppraisalV2 } from '@/models/registry';
import { useNavigate } from '@tanstack/react-router';

const TradeInListMobile = ({ appraisals }: { appraisals?: AppraisalV2[] }) => {
  const navigate = useNavigate();
  const list = appraisals ?? [];
  const hasItem = list.length > 0;

  return (
    <div
      className={`md:hidden grid grid-cols-[1fr_auto_24px] gap-1 items-center w-full`}
    >
      <div className="text-sm text-uneditable">Trade-in List</div>
      <div className="text-sm text-right">
        {!hasItem ? (
          <span className="text-uneditable">None</span>
        ) : (
          <div className="flex flex-wrap gap-1 justify-end">
            {list.map((a) => (
              <Button
                key={a.id}
                variant="outline"
                size="xs"
                onClick={() => navigate({ to: getAppraisalPathname(a.id) })}
                className="text-xs rounded-full"
              >
                {a.year} {a.make} {a.model}
              </Button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default TradeInListMobile;
